import React from 'react';
import Modal from 'Utils/Modal';
import * as actions from 'Actions';
import { connect } from 'react-redux';
import service from 'Api/service';
import { saveError } from 'Api';
import { RemoveCircle } from 'Utils/SvgIcons';
import Endpoints from 'Api/endpoints';
import ScrollArea from 'Utils/react-scrollbar';

class MaintainModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      selected: [],
      serialNumber: '',
    };
  }

  UNSAFE_componentWillMount() {
    if (this.props.serialProduct) {
      this.setState({
        selected: [this.props.serialProduct],
      });
    }
    if (!!this.props.serialProducts?.length) {
      this.setState({ selected: this.props.serialProducts });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (
      this.props.serialProducts?.length !== nextProps.serialProducts?.length
    ) {
      this.setState({ selected: nextProps.serialProducts });
    }
  }

  handleChange = (event) => {
    const { name, value } = event.target;
    this.setState({
      [name]: value,
    });
  };

  handleSerialNumberReset = () => {
    this.setState({
      serialNumber: '',
    });
  };

  performSearch = (event) => {
    event.preventDefault();
    const { product, setErrors } = this.props;
    const { serialNumber } = this.state;
    const component = this;
    Endpoints.serializedProducts
      .showBySerialNumber(product, serialNumber)
      .then((response) => {
        const { selected } = component.state;
        const { serializedProduct } = response.data;
        const foundIndex = selected.findIndex(
          (sp) => sp.serialNumber === serializedProduct.serialNumber
        );
        if (foundIndex === -1) {
          component.setState({
            selected: [...selected, serializedProduct],
            serialNumber: '',
          });
        } else {
          setErrors('Serial number already added.');
          component.setState({
            serialNumber: '',
          });
        }
      })
      .catch((error) => {
        setErrors('Unknown/invalid token provided.');
        console.log(error);
      });
  };

  handleSubmit = () => {
    const { selected } = this.state;
    const { toggle, isProductRow } = this.props;

    // Validation
    if (selected.length === 0) {
      this.props.setErrorMessage({
        field: 'selected',
        text: 'You need to select at least one serialized item.',
      });
    } else {
      const { product } = this.props;
      const component = this;
      const { selected } = component.state;
      const ids = selected.map((s) => s.id);
      service
        .post(
          import.meta.env.VITE_API_DOMAIN +
            `/api/products/${product.id}/serialized_products/bulk_maintain`,
          {
            ids: ids,
          }
        )
        .then((response) => {
          component.props.openSuccessSnackBar(response.data.message);
          if (component.props.onRefresh) {
            component.props.onRefresh();
          }

          if (isProductRow) {
            toggle();
          }
        })
        .catch((error) => {
          console.log(error);
          saveError(error);
        });
    }
  };

  removeItem = (serialNumber) => {
    const newSelected = this.state.selected.filter(
      (s) => s.serialNumber !== serialNumber
    );
    this.setState({
      selected: newSelected,
    });
  };

  render() {
    const { product, open, toggle } = this.props;
    const { serialNumber, selected } = this.state;

    return (
      <Modal
        open={open}
        toggle={toggle}
        large={true}
        className='serializedModal'
        title='Put Serialized Items in Maintenance'
        actions={[
          <a className='btn' onClick={this.handleSubmit}>
            Submit And Update Rental Inventory
          </a>,
          <a className='btn cancel' onClick={toggle}>
            Cancel
          </a>,
        ]}
      >
        <div>
          <h2>{product.name}</h2>
          <div className='fullForm'>
            <input
              type='text'
              name='serialNumber'
              className='barcode'
              onChange={this.handleChange}
              value={serialNumber}
            />
            <a className='btn' onClick={this.performSearch}>
              Add Item to Maintenance List
            </a>
            <a className='btn cancel' onClick={this.handleSerialNumberReset}>
              Cancel
            </a>
          </div>
          <ScrollArea speed={0.8} horizontal={false}>
            <section>
              <h4>Total</h4>
              <strong>{selected.length}</strong>
              <table className='grid'>
                <thead>
                  <tr>
                    <th>Serial No</th>
                    <th className='actionSm' />
                  </tr>
                </thead>
                <tbody>
                  {selected.map((s, index) => (
                    <tr key={index}>
                      <td>{s.serialNumber}</td>
                      <td>
                        <a
                          className='btnLink remove'
                          onClick={() => this.removeItem(s.serialNumber)}
                        >
                          <RemoveCircle />
                        </a>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </section>
          </ScrollArea>
        </div>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => {
  const { rental, loading } = state.rental;
  const { errors } = state.dashboard;
  return { rental, loading, errors };
};

export default connect(mapStateToProps, actions)(MaintainModal);
